<div class="documentReviewWrapper shadowHover" (click)="view()">
  <img src="../../../../../assets/Icon-FileUploaded.svg" alt="pdfIcon" />
  <span>{{ documentName }}</span>
</div>
